import { TextField } from '@livefree/uniformly';

export const StyledTextField = ({ ...rest }) => (
  <TextField
    {...rest}
    classNames={{
      inputWrapper:
        'border-transparent bg-white/10 dark:bg-white/10 group-data-[focus=true]:border-primary data-[hover=true]:border-foreground/20',
    }}
    variant="faded"
  />
);
